<template>
  <div class="add-team-combobox-item d-flex align-center">
    <app-button class="teams-btn-icon mr-3" type="ghost"
    >
      <app-icon icon-name="users" icon-weight="far" size="medium" />
    </app-button>
    <div>
      <!-- Team -->
      <p class="text-grey-800 mb-1 text--small text--bold">
        {{ item.name }}
      </p>
      <!-- Members -->
      <p v-if="withMembers"
                class="text--x-small text-grey-700 mb-1"
      >
        <span v-t="{ path: 'subscriptions.views.SubscriptionTeams.memberCount', plural: item.members.length }" />
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AddTeamComboboxItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      withMembers: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="scss">
  .add-team-combobox-item {
    .teams-btn-icon {
      width: 32px;
      height: 32px;
      min-height: 0;
      border-radius: 50%;
      color: rgb(var(--v-theme-grey-500));
      background-color: rgb(var(--v-theme-grey-100));
    }
  }
</style>
